import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  public get<TModel>(key: string): TModel {
    const payload = sessionStorage.getItem(key);
    if (_.isNil(payload)) {
      return payload
    }
    return Object.assign({}, JSON.parse(sessionStorage.getItem(key))) as TModel;
  }

  public store<TModel>(key: string, value: TModel): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  public remove(key: string): void {
    sessionStorage.removeItem(key);
  }
}
